import React from 'react';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import { MapPlaceholder } from '../form/MapPlaceholder';
export function OfficeCard({
  address
}: {
  address: string;
}) {
  return <section className="w-full bg-canvas-warm py-20" aria-labelledby="visit-heading" data-id="element-340" data-mp="3jvfnszfcrxxz">
      <div className="mx-auto max-w-shell px-6" data-id="element-341" data-mp="3fr7zh3ct4k0a">
        <div className="grid grid-cols-1 items-center gap-8 rounded-[14px] bg-white p-6 sm:p-8 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-12" data-id="element-342" data-mp="3funa9tzg76vw">
          <div data-id="element-343" data-mp="3os63vmr5qtje">
            <h2 id="visit-heading" className="display text-[30px] font-semibold text-ink sm:text-[36px]" data-id="element-344" data-mp="3osp9q53j9rh2">
              Visit us
            </h2>
            <p className="mt-3 max-w-[400px] text-[16px] leading-[1.55] text-ink-muted" data-id="element-345" data-mp="2cury9p0z6k0">
              Our team works from Kigali. Drop by to meet us, or book a time and we’ll have coffee ready.
            </p>
            <p className="mt-6 flex items-center gap-2.5 text-[16px] font-semibold text-ink" data-id="element-346" data-mp="beuax7jlokpl">
              <MapPinIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-347" data-mp="176jmkrmsutiy" />
              {address}
            </p>
            <SmartLink href="/contact" className="group mt-6 inline-flex items-center gap-1.5 text-[15px] font-semibold text-brand transition-colors duration-150 ease-out hover:text-brand-hover" data-id="element-348" data-mp="1c65vwpzibpmh">
              Get in touch
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-349" data-mp="1q55kjxn0s4in" />
            </SmartLink>
          </div>
          <MapPlaceholder address={address} data-id="element-350" data-mp="1zufg5nh2o5bi" />
        </div>
      </div>
    </section>;
}